import * as AppConstants from 'app/AppConstants';
import {OPERANDS_BY_VALUE} from 'constants/FilterConstants';
import {loadDataSourcesByCardId} from 'state/dataSource/dataSourceActions';

const OPERAND_VALUES = new Set(Object.keys(OPERANDS_BY_VALUE));

const assertHasColumn = (f) => {
  if (!f.column) throw Error('column is required');
};
const assertHasValues = (f) => {
  if (!Array.isArray(f.values)) throw Error('values must be an Array');
};
const assertHasOperand = (f) => {
  if (!f.operand) throw Error('operator is required');
};

const assertOperandType = (f) => {
  if (!OPERAND_VALUES.has(f.operand)) throw Error(`invalid operator type`);
};

const pluckFilterProps = ({column, values, operator, operand}) => ({
  column,
  values,
  // External "operator" API
  operand: operator || operand,
});

export const applyFilters = (cardId, filters) => (dispatch) => {
  const cleanFilters = filters.map(pluckFilterProps);

  cleanFilters.forEach((f) => {
    assertHasColumn(f);
    assertHasValues(f);
    assertHasOperand(f);
    assertOperandType(f);
  });

  dispatch(loadDataSourcesByCardId(cardId)).then(() =>
    dispatch({
      type: AppConstants.RPC__FILTERS_APPLIED,
      payload: {
        cardId,
        filters: cleanFilters,
      },
    })
  );
};
